var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 0.666687C9.46032 0.666687 9.83342 1.03978 9.83342 1.50002V8.16669H16.5001C16.9603 8.16669 17.3334 8.53978 17.3334 9.00002C17.3334 9.46026 16.9603 9.83335 16.5001 9.83335H9.83342V16.5C9.83342 16.9603 9.46032 17.3334 9.00008 17.3334C8.53984 17.3334 8.16675 16.9603 8.16675 16.5V9.83335H1.50008C1.03984 9.83335 0.666748 9.46026 0.666748 9.00002C0.666748 8.53978 1.03984 8.16669 1.50008 8.16669H8.16675V1.50002C8.16675 1.03978 8.53984 0.666687 9.00008 0.666687Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusTheme);
export default __webpack_public_path__ + "static/media/plus-theme.3a0b15baaa166a17940093e22288c547.svg";
export { ForwardRef as ReactComponent };